export default __webpack_public_path__ + "static/media/Linero5Open.e219f6d7.jpg";